import { render, staticRenderFns } from "./SubmissionBox.vue?vue&type=template&id=937e5e6e&scoped=true"
import script from "./SubmissionBox.vue?vue&type=script&lang=js"
export * from "./SubmissionBox.vue?vue&type=script&lang=js"
import style0 from "./SubmissionBox.vue?vue&type=style&index=0&id=937e5e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937e5e6e",
  null
  
)

export default component.exports